
	/**
	 * @description
	 *  Modelo de un vector de la estructura comercial.
	 *
	 * @see gigot-backend/Core/Query/StructureVector.cs
	 */

export class StructureVector {

	public campaignId: number;
	public areaLevelId: number;
	public zoneLevelId: number;
	public divisionLevelId: number;
	public commerceLevelId: number;
	public countryLevelId: number;

	/**
	 * @description
	 *	Construye un vector de estructura con una semántica vacía. Nótese que
	 *	no es lo mismo que construir un vector con valores por defecto. Las
	 *	reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un vector vacío.
	 */
	public static empty(): StructureVector {
		const structureVector: StructureVector = new StructureVector();
		structureVector.campaignId = undefined;
		structureVector.areaLevelId = undefined;
		structureVector.zoneLevelId = undefined;
		structureVector.divisionLevelId = undefined;
		structureVector.commerceLevelId = undefined;
		structureVector.countryLevelId = undefined;
		return structureVector;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicIndicator
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicStructureVector: StructureVector): StructureVector {
		if (!anemicStructureVector) return undefined;
		const structureVector: StructureVector = StructureVector.empty();
		structureVector.campaignId = anemicStructureVector.campaignId;
		structureVector.areaLevelId = anemicStructureVector.areaLevelId;
		structureVector.zoneLevelId = anemicStructureVector.zoneLevelId;
		structureVector.divisionLevelId = anemicStructureVector.divisionLevelId;
		structureVector.commerceLevelId = anemicStructureVector.commerceLevelId;
		structureVector.countryLevelId = anemicStructureVector.countryLevelId;
		return structureVector;
	}
}
